const COMMON_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com.br',
  'yahoo.com',
  'icloud.com',
  'bol.com.br',
  'uol.com.br',
  'terra.com.br',
  'live.com',
  'msn.com',
  'globo.com',
  'ig.com.br',
  'r7.com',
  'zipmail.com.br',
  'protonmail.com',
  'proton.me'
];

const MAX_DISTANCE = 2;

function levenshtein(a, b) {
  const matrix = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));

  for (let i = 0; i <= a.length; i += 1) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j += 1) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;

      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }

  return matrix[a.length][b.length];
}

function findClosestDomain(domain) {
  let bestMatch = null;
  let bestDistance = Infinity;

  COMMON_DOMAINS.forEach(knownDomain => {
    const distance = levenshtein(domain, knownDomain);

    if (distance > 0 && distance <= MAX_DISTANCE && distance < bestDistance) {
      bestDistance = distance;
      bestMatch = knownDomain;
    }
  });

  return bestMatch;
}

export default function suggestEmail(value) {
  const trimmedValue = (value || '').trim();

  if (!trimmedValue.includes('@')) return null;

  const atIndex = trimmedValue.lastIndexOf('@');
  const localPart = trimmedValue.slice(0, atIndex).trim();
  const domainPart = trimmedValue.slice(atIndex + 1).trim().toLowerCase();

  if (!localPart || !domainPart) return null;
  if (COMMON_DOMAINS.includes(domainPart)) return null;

  const suggestedDomain = findClosestDomain(domainPart);

  if (!suggestedDomain) return null;

  return {
    full: `${localPart}@${suggestedDomain}`,
    domain: suggestedDomain
  };
}
